import React from 'react';
import styled from 'styled-components';
import { Collapse, Icon } from 'antd';
import moment from 'moment';

const Panel = Collapse.Panel;

const Wrapper = styled.div`
  padding: 10px;
  h3 {
    color: white;
  }
`;

const ViewEventSidebar = ({ annotation, onClose }) => {
  const metaFields = Object.keys(annotation.additionalData)
    .filter(
      k =>
        annotation.additionalData[k] && annotation.additionalData[k].length > 0
    )
    .map(k => ({
      key: k,
      value: annotation.additionalData[k],
    }));
  return (
    <Wrapper>
      <h3>
        TYPE: <strong>{annotation.type}</strong>
        <Icon
          type="close-circle-o"
          style={{
            color: 'white',
            float: 'right',
            cursor: 'pointer',
            fontSize: '1.2rem',
          }}
          onClick={onClose}
        />
      </h3>
      <h3>
        SUB TYPE: <strong>{annotation.subtype}</strong>
      </h3>
      <h3>
        START TIME:{' '}
        <strong>
          {moment(annotation.startTime).format('YYYY/MM/DD HH:mm:ss')}
        </strong>
      </h3>
      <h3>
        END TIME:{' '}
        <strong>
          {moment(annotation.endTime).format('YYYY/MM/DD HH:mm:ss')}
        </strong>
      </h3>
      <h3>
        <strong>{annotation.description}</strong>
      </h3>
      <Collapse defaultActiveKey={[Object.keys(annotation.additionalData)[0]]}>
        {metaFields.map(a => (
          <Panel header={a.key} key={a.key}>
            <p>{a.value}</p>
          </Panel>
        ))}
      </Collapse>
    </Wrapper>
  );
};

ViewEventSidebar.propTypes = {};

export default ViewEventSidebar;



// WEBPACK FOOTER //
// ./src/components/ChartView/ViewEventSidebar.js